import { Component } from '@theme/component';

/** Progressive audience tabs; collection navigation works without this module. */
export default class EchtCategoryBrowser extends Component {
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const tabs = [...this.querySelectorAll('[role="tab"]')];
    const tablist = this.querySelector('[role="tablist"]');
    if (!tabs.length || !tablist) return;

    for (const tab of tabs) {
      const panel = this.querySelector(`[data-panel="${tab.dataset.audience}"]`);
      panel?.setAttribute('role', 'tabpanel');
      panel?.setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', () => this.#select(tab.dataset.audience), { signal });
      tab.addEventListener('keydown', (event) => {
        const index = tabs.indexOf(tab);
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.#select(tabs[next].dataset.audience);
        tabs[next].focus();
      }, { signal });
    }
    this.#select(this.dataset.defaultAudience || 'women');
    this.setAttribute('data-enhanced', '');
    tablist.hidden = false;
    this.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-panel]');
      if (panel) this.#select(panel.dataset.panel);
    }, { signal });
  }

  #select(audience) {
    for (const tab of this.querySelectorAll('[role="tab"]')) {
      const selected = tab.dataset.audience === audience;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    }
    for (const panel of this.querySelectorAll('[data-panel]')) {
      panel.hidden = panel.dataset.panel !== audience;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }
}

if (!customElements.get('echt-category-browser')) customElements.define('echt-category-browser', EchtCategoryBrowser);
